/* eslint-disable func-names */
$(document).ready(() => {
    const sanitizeSearchInput = () => {
        $('[name="Terms"]').each(function () {
            const inputField = $(this);
            const value = inputField.val();
            if (value === undefined) return;
            const sanitizedValue = value.replace(/\*+$/, '');
            if (value !== sanitizedValue) {
                inputField.val(sanitizedValue);
            }
        });
    };

    sanitizeSearchInput();

    $('.searchAutocomplete, .search-box').on('submit', () => {
        sanitizeSearchInput();
        $('[name="Terms"]').each(function () {
            const searchInput = $(this);
            if (searchInput.val().trim() && !searchInput.val().endsWith('*')) {
                searchInput.val(searchInput.val().trim() + '*');
            }
        });
    });
    $('.one-time-click').on('click', function () {
        $(this).css('pointer-events', 'none');
    });
});
